import Vue from 'vue';
import VueMeta from 'vue-meta';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import { loadProjectConfiguration } from '@user/api';

import baseIcon from '@shared/components/Icons/BaseIcon';
import loader from '@user/components/Loader';
// Hier wird der "alte" Modal-Komponent verfügbar gemacht. Er wird in den Legacy-Projekten und Komponenten verwendet.
import modal from '@shared/components/Modal';
import appError from '@user/components/Error';
import appErrorShared from '@shared/components/Error';
import App from '@user/AppComponent';
import { routeDebug as debug } from '@user/util/debuggers';
import { createRouter } from '@user/router';
import { createStore } from '@user/store';
import { initAPI } from '@user/api/helpers/sendRequest';
import { texts } from '@user/texts/default';
import { sharedTexts } from '@shared/texts/default';

import blurDirective from '../shared/directives/blurDirective';
import GlobalErrorHandler from '../shared/error';

const projectParam = window.location.pathname.split('/')[1];

const urlparm = window.location.search;

async function projectSetup(store, config) {
  await store.dispatch('setCSTM', projectParam);
  const combinedTexts = { ...texts, ...sharedTexts };

  await store.dispatch('setTexts', combinedTexts);
  await store.dispatch('setProjectConfig', config);
}

// eslint-disable-next-line import/no-mutable-exports
export let configForExport;
async function initializeProjectConfig() {
  // ConfigController muss wissen, ob der User gerade im default oder onsite StepType sich befindet, schon bevor das Login geladen wird, deshalb übergeben wir hier den kompletten urlparm der in window.location.search steckt
  const { status, config } = await loadProjectConfiguration(urlparm);
  configForExport = config;
  let router;
  let store;

  // Diese appHeight-Berechnung dient dazu den 100vh-Bug in iOS entgegenzuwirken.
  // Dort ist 100vh NICHT die sichtbare Viewport-Größe, sondern auch die Adressleiste
  const appHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty('--app-height', `${window.innerHeight}px`);
  };
  window.addEventListener('resize', appHeight);
  appHeight();

  if (status === 'OK') {
    router = createRouter(projectParam, config.extensions, config.exclude);
    store = createStore(router);

    router.beforeEach((to, _from, next) => {
      debug(`from %o to %o`, _from, to);
      store.dispatch('setLayout', to.meta.layout || 'Dashboard');
      next();
    });
    await projectSetup(store, config);
  } else {
    router = createRouter();
    store = createStore(router);
  }
  return { router, store };
}

initAPI(projectParam);

// Vue Config
Vue.config.errorHandler = GlobalErrorHandler.vueErrorHandler;

Vue.use(VueMeta);

Vue.directive('blur', blurDirective);
Vue.use(VueRouter);
Vue.use(Vuex);

Vue.component('BaseIcon', baseIcon);
Vue.component('Loader', loader);
Vue.component('LegacyModal', modal);
Vue.component('AppError', appError);
Vue.component('AppErrorShared', appErrorShared);

initializeProjectConfig().then(
  (response) => {
    const { store, router } = response;
    new GlobalErrorHandler(window || global, store).init();

    /* eslint-disable no-new */
    new Vue({
      el: '#app',
      components: { App },
      router,
      store,
    });
  }
  // ,
  // () => {
  //   console.log('Project initialization rejected');
  // }
);
